var $0b159f35b37c5d0e$exports = {};
$0b159f35b37c5d0e$exports = {
    "actions": `Dejanja`,
    "hideButtonLabel": `Prika\u{17E}i manj`,
    "noTags": `Ni\u{10D}`,
    "showAllButtonLabel": (args, formatter)=>`Prika\u{17E} vse (${formatter.number(args.tagCount)})`
};


export {$0b159f35b37c5d0e$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
